import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getBaseUnit,
  getParticularPage,
  getNext,
  getPrevious,
  createBaseUnit,
  updateBaseUnit,
  handleSearch,
} from "./thunk";

const initialState = {
  baseUnits: [],
  edit: false,
  baseUnit: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingBaseUnit: false,
  loadingNext: false,
  showCreateModal: false,
  // New state properties for form persistence
  formData: {
    name: "",
    shortForm: "",
    displayOrder: "",
    parent: null,
    isActive: true,
  },
  activeBaseUnitId: null,
};

export const baseUnitSlice = createSlice({
  name: "baseUnit",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    baseUnitEditSuccess: (state, action) => {
      state.edit = true;
      state.baseUnit = state.baseUnits.find((baseUnit) => baseUnit.id === action.payload);
      state.formData = state.baseUnits.find((baseUnit) => baseUnit.id === action.payload);
      state.activeBaseUnitId = action.payload;
    },
    clearAllBaseUnit: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingBaseUnit = false;
      state.baseUnit = null;
      state.activeBaseUnitId = null;

      state.formData = initialState.formData;
    },
    resetBaseUnitForm: (state, action) => {
      if (action.payload) {
        // if edit is true, reset to baseUnit data
        state.formData = state.baseUnit;
      } else {
        state.formData = initialState.formData; // if edit is false, reset to initial state
        state.activeBaseUnitId = null;
      }
    },
    // New reducers for form persistence
    saveBaseUnitForm: (state, action) => {
      state.formData = action.payload;
    },
    clearBaseUnitForm: (state) => {
      state.formData = initialState.formData;
      state.activeBaseUnitId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createBaseUnit.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createBaseUnit.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;

      state.formData = initialState.formData; // Clear form on success
    });
    builder.addCase(createBaseUnit.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateBaseUnit.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateBaseUnit.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;

      state.formData = initialState.formData; // Clear form on success
    });
    builder.addCase(updateBaseUnit.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getBaseUnit.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingBaseUnit = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBaseUnit.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingBaseUnit = false;
        state.baseUnits = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBaseUnit.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingBaseUnit = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  baseUnitEditSuccess,
  saveBaseUnitForm,
  resetBaseUnitForm,
  clearBaseUnitForm,
  clearAllBaseUnit,
} = baseUnitSlice.actions;

export default baseUnitSlice.reducer;
